import React from 'react';
import * as yup from 'yup';
import { Box, Grid, Typography } from '@mui/material';
import {
  SparkForm,
  SparkFormButton,
  SparkFormResetButton,
  SparkTextField,
} from 'sharedComponents/SparkForm';
import { Account } from 'types/Account';
import { useUpdateAccount } from 'hooks/Account/useUpdateAccount';

type AddressSectionForm = {
  address1: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
};

type AddressSectionProps = {
  account: Account | undefined;
  isAdmin: boolean;
};

function AddressSection({ account, isAdmin }: AddressSectionProps) {
  const { mutateAsync: UpdateAccountUser } = useUpdateAccount(account?.id);
  const initialValues = {
    address1: account?.attributes.address1 ?? '',
    address2: account?.attributes.address2 ?? '',
    city: account?.attributes.city ?? '',
    state: account?.attributes.state ?? '',
    postalCode: account?.attributes.postalCode ?? '',
  };

  const validationSchema = yup.object({
    address1: yup.string().required(),
    address2: yup.string(),
    city: yup.string(),
    state: yup.string(),
    postalCode: yup.string(),
  });

  const handleSave = async (values: AddressSectionForm) => {
    await UpdateAccountUser(values);
  };

  return (
    <Grid container marginTop={2}>
      <Typography
        variant='h5'
        sx={{
          fontFamily: 'Mont-semibold',
          marginBottom: 2,
        }}
      >
        Address
      </Typography>
      <Box
        width='100%'
        bgcolor='white'
        borderRadius='20px'
        border={(theme) => `1px solid ${theme.palette.borderColor}`}
      >
        <SparkForm<AddressSectionForm>
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSave={handleSave}
          containerProps={{ spacing: 2, padding: 2 }}
        >
          <SparkTextField
            name='address1'
            label='Address 1'
            placeholder='Address 1'
            readonly={!isAdmin}
          />
          <SparkTextField
            name='city'
            label='City'
            placeholder='City'
            readonly={!isAdmin}
          />
          <SparkTextField
            name='postalCode'
            label='Postal Code'
            readonly={!isAdmin}
            placeholder='Postal Code'
          />
          <SparkTextField
            name='address2'
            label='Address 2'
            placeholder='Address 2'
            readonly={!isAdmin}
          />
          <SparkTextField
            name='state'
            label='State'
            placeholder='State'
            readonly={!isAdmin}
          />

          {isAdmin && (
            <Grid
              item
              container
              xs={12}
              gap={2}
              justifyContent='flex-end'
              flexWrap='nowrap'
            >
              <SparkFormResetButton
                variant='outlined'
                sx={{ width: '200px', padding: '10px 20px', marginTop: '10px' }}
              >
                Cancel
              </SparkFormResetButton>
              <SparkFormButton
                sx={{ width: '200px', padding: '10px 20px', marginTop: '10px' }}
              >
                Save
              </SparkFormButton>
            </Grid>
          )}
        </SparkForm>
      </Box>
    </Grid>
  );
}

export default AddressSection;
